import { assert } from '@deqo/foundation';
import { EmojiSprite } from './EmojiSprite';
import { EmojiStore } from './EmojiStore';

export function emojiImage(sprite: EmojiSprite, idOrCode: string, size?: number): string {
    size = size || sprite.cellSize;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    emojiDraw(sprite, canvas.getContext('2d')!, idOrCode, 0, 0, size);

    return canvas.toDataURL();
}

export function emojiDraw(
    sprite: EmojiSprite,
    gfx: CanvasRenderingContext2D,
    idOrCode: string,
    x: number = 0,
    y: number = 0,
    size?: number): void {

    size = size || sprite.cellSize;

    const emoji = EmojiStore.find(idOrCode);
    const ox = (emoji.order - 1) % sprite.columns;
    const oy = Math.floor((emoji.order - 1) / sprite.columns);
    const scale = size / sprite.cellSize;

    gfx.drawImage(
        sprite.data,
        (ox * sprite.cellSize),
        (oy * sprite.cellSize),
        72,
        72,
        x,
        y,
        72 * scale,
        72 * scale
    );
}

export function emojiHtml(code: string, inline?: boolean): string {
    const e = EmojiStore.find(code);
    const classes = ['emoji', !!inline ? 'emoji-inline' : '', 'emoji-' + e.id].join(' ');
    if (e) return `<span class="${classes}"></span>`;
    throw new Error('Invalid emoji code: ' + code);
}

export const emojiToString = (id: string) => {
    const data = EmojiStore.find(id);
    assert(!!data, `Could not find emoji: ${id}`);
    return data.id.split('-').join('-200d-').split('-').map(x => String.fromCodePoint(parseInt(x, 16))).join('');
};
